import { v1 as uuidv1 } from 'uuid';

import LocalStorageHelper from './LocalStorage';

const STORAGE_KEY = 'trace-token';

function generateToken () {
    return uuidv1().replace(/-/g, '');
}

class TraceToken {
    count = 0;

    constructor () {
        const token = LocalStorageHelper.getItem(STORAGE_KEY);
        let sessionToken, count;

        if (token) {
            [sessionToken, count] = token.split('-');
        }

        if (!sessionToken) {
            this.refresh();
        } else {
            this.sessionToken = sessionToken;
            this.count = count;
        }
    }

    _store () {
        LocalStorageHelper.setItem(STORAGE_KEY, `${this.sessionToken}-${this.count}`);
    }

    refresh () {
        const sessionToken = generateToken();
        this.sessionToken = sessionToken;
        this.count = 0;
        this._store();
    }

    getToken () {
        this.count++;
        this._store();
        return `${this.sessionToken}-${this.count}`;
    }
}

const instance = new TraceToken();

export default instance;
